<template>
<div>
    <Navbar />
    <Message v-if="this.added_collection" :message="this.message" />
    <div v-if="no_content == true" class="flex flex-col h-screen">
        <div class="w-full">
            <div class="flex flex-row justify-center items-center" style="height:200px">
                <font-awesome-icon class="text-green-700 text-4xl cursor-pointer  mr-8" :icon="['fas', 'university']" />
                <div class="text-xl lg:text-4xl md:text-4xl font-bold text-green-900  "> {{institute_name}}</div>
            </div>

            <div class="mt-3 flex content-around justify-center items-center ">
                <div class="flex flex-row md:w-2/4">
                    <div class="w-10/12 md:w-11/12">
                        <input class="w-full border-2 p-2 rounded-l-lg pt-3 px-6 focus:outline-none focus:border focus:border-blue-400" placeholder="Aswin G, Nature, IISc etc" v-model="searchString" type="text" />
                    </div>
                </div>
            </div>

            <div class="flex flex-col lg:flex-row ">
                <div class=" flex flex-col " style="flex:3">
                    <div class="w-full flex flex-row">
                        <div id="articles_details" class="m-2 flex flex-col w-full">
                            <p class="font-bold text-2xl text-green-500">Publications</p>

                            <div v-if='checkedNames.length'>

                                <div class="m-2 ">
                                    <span @click="ClickCollection()" class="p-2 w-auto text-sm rounded-md bg-green-600 border text-white font-semibold border-gray-200 select-none cursor-pointer" v-if='checkedNames.length'>Add to Collection</span>
                                </div>
                                <a class="absolute " title="Add To Collections">
                                    <div v-if="isOpen">

                                        <ul class="bg-white rounded-lg shadow-lg ">
                                            <span v-for="n in collectionData" :key="n">

                                                <li class="py-3 px-6 hover:bg-gray-100" @click="addCollectionmulti(n)">
                                                    {{n.name.split(":")[0]}}
                                                </li>
                                            </span>
                                        </ul>
                                    </div>
                                </a>
                            </div>

                            <div v-for="pub in filteredFiles" :key="pub" class="w-full flex flex-col py-4 border rounded-md shadow-lg px-4 cursor-pointer mb-3">
                                <div class="w-max bg-gray-100 text-xs items-center justify-left rounded-md px-1.5 py-0.8 text-black ">{{pub.pub_type[0]}}</div>
                                <div class="w-full h-auto flex flex-row">
                                    <input class="h-10 mr-2 rounded rounded-xs ring-1 focus:ring-1 ring-purple-500 focus:ring-pink-500  text-pink-600 border-gray-300" type="checkbox" :value="pub.id[0]" v-model="checkedNames">
                                    <div class="w-full lg:w-11/12 flex flex-row item-center justify-start">
                                        <a :href="'/' + pub.title[0] + '/' + pub.id[0]">
                                            <h1 class="text-justify text-sm md:text-lg lg:text-xl text-blue-800 py-1">{{pub.title[0]}}</h1>
                                        </a>
                                    </div>
                                    <div v-if="checkedNames.length == 0" class="hidden lg:w-1/12 lg:flex lg:flex-row lg:justify-end lg:self-top justify-end lg:self-end">
                                        <a v-if="pub.pdf_url[0]" :href="pub.pdf_url[0]" title="Pdf Download">
                                            <div class="m-1 w-7 h-7 bg-green-100 flex flex-row item-center justify-center  rounded-full  hover:bg-green-300">
                                                <font-awesome-icon class="text-sm text-green-600 self-center" :icon="['fas', 'download']" />
                                            </div>
                                        </a>
                                        <div>
                                            <div @click="ClickCollection(pub.id[0])" class="m-1 w-7 h-7 bg-green-100 flex flex-row item-center justify-center border-green-400 rounded-full  hover:bg-green-300 ">
                                                <font-awesome-icon class="text-sm text-green-600 self-center" :icon="['fas', 'plus-circle']" />
                                            </div>
                                            <a class="absolute " title="Add To Collections">
                                                <div v-if="isOpen && collection == pub.id[0]" :id="pub.id[0]">

                                                    <ul class="bg-white rounded-lg shadow-lg ">
                                                        <span v-for="n in collectionData" :key="n">

                                                            <li class="py-3 px-6 hover:bg-gray-100" @click="addCollection(n, pub.id)">
                                                                {{n.name.split(":")[0]}}
                                                            </li>
                                                        </span>
                                                    </ul>
                                                </div>
                                            </a>
                                        </div>

                                        <a v-if="pub.html_url[0] && pub.html_url[0] !='' " :href="pub.html_url[0]" title="Goto Journal Website">
                                            <div class="m-1 w-7 h-7 bg-green-100 flex flex-row item-center justify-center  rounded-full  hover:bg-green-300">
                                                <font-awesome-icon class="text-sm text-green-600 self-center" :icon="['fas', 'link']" />
                                            </div>
                                        </a>
                                    </div>
                                </div>

                                <div>
                                    <div class="text-letf">
                                        <h1 class="text-left text-sm md:text-md lg:text-md text-green-700 py-1">
                                            {{pub.journal[0]}}( IF:{{pub.impact_factor[0]}} ).
                                            {{pub.pub_date[0]}}.
                                            <font-awesome-icon class="text-xs ml-1 mr-1" :icon="['fas', 'quote-right']" />{{pub.citation_count[0]}}
                                        </h1>
                                    </div>
                                    <div class="">
                                        <a v @click="auth_page(pub)" class="text-left h-12 md:h-auto overflow-hidden">
                                            <span v-for="author in pub.author_name.slice(0,5)" :key="author" class="text-xs text-gray-700 md:text-md lg:text-md">{{author}}, </span>
                                        </a>
                                    </div>

                                </div>

                                <div class="flex flex-row justify-between ">

                                    <div v-if="pub.abstract_text[0].length > 2">
                                        <div class="hover:bg-green-100 w-max bg-gray-100 text-sm items-center px-2 mt-2 text-right">
                                            <div @click="abstract_show(pub.id[0])" style="color: #00b2b2" class="flex flex-row text-letf">
                                                Abstract
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="checkedNames.length == 0" class="lg:hidden w-full flex flex-row justify-end self-end">
                                        <a v-if="pub.pdf_url[0]" :href="pub.pdf_url[0]" title="Pdf Download">
                                            <div class="m-1 w-7 h-7 bg-green-100 flex flex-row item-center justify-center  rounded-full  hover:bg-green-300">
                                                <font-awesome-icon class="text-sm text-green-600 self-center" :icon="['fas', 'download']" />
                                            </div>
                                        </a>
                                        <div>
                                            <div @click="ClickCollection(pub.id[0])" class="m-1 w-7 h-7 bg-green-100 flex flex-row item-center justify-center border-green-400 rounded-full  hover:bg-green-300 ">
                                                <font-awesome-icon class="text-sm text-green-600 self-center" :icon="['fas', 'plus-circle']" />
                                            </div>
                                            <a class="absolute" title="Add To Collections">
                                                <div v-if="isOpen && collection == pub.id[0]" :id="pub.id[0]">

                                                    <ul class="bg-white rounded-lg shadow-lg ">
                                                        <span v-for="n in collectionData" :key="n">

                                                            <li class=" py-3 px-4 hover:bg-gray-100 text-xs" @click="addCollection(n, pub.id)">
                                                                {{n.name.split(":")[0]}}
                                                            </li>
                                                        </span>
                                                    </ul>
                                                </div>
                                            </a>
                                        </div>
                                        <a v-if="pub.html_url[0] && pub.html_url[0] !='' " :href="pub.html_url[0]" title="Goto Journal Website">
                                            <div class="m-1 w-7 h-7 bg-green-100 flex flex-row item-center justify-center  rounded-full  hover:bg-green-300">
                                                <font-awesome-icon class="text-sm text-green-600 self-center" :icon="['fas', 'link']" />
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class="text-justify" v-if="isHidden && abstract_id == pub.id[0]">
                                    <p>{{ pub.abstract_text[0]}}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="institute_auth.length != 0" class=" mt-3 flex flex-col" style="flex:1">
                    <div class="m-2 ">
                        <p class="font-bold text-2xl text-green-500">Authors</p>
                        <div class="sm:w-1/2 mt-1 lg:w-full  flex flex-col   border rounded-sm  bg-opacity-30">
                            <div v-for="author in institute_auth" :key="author" class="flex flex-row py-1 border-b text-black  px-4 cursor-pointer hover:bg-green-100">
                                <div class=" lg:w-11/12  flex flex-row item-center justify-start">
                                    <a :href="'/author/' + author[0].author_name + '/' + author[0].author_slug.split('-')[0]">
                                        <h1 class="text-justify text-xs md:text-sm lg:text-xs text-black py-1">{{author[0].author_name}}</h1>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    </div>
    <div v-else class="w-full h-full">
        <div wire:loading class="fixed left-0 right-0 bottom-0 w-full h-screen overflow-hidden opacity-75 flex flex-col items-center justify-center">
            <div class="empty-icon-container">
                <div class="animation-container">
                    <div class="bounce" style="background-image:url('data:image/png;base64,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')"></div>
                    <div class="pebble1"></div>
                    <div class="pebble2"></div>
                    <div class="pebble3"></div>
                </div>
                <div>
                    <h2>Loading...</h2>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Message from '@/components/FlashMessage.vue';
import {
    ref,
    computed
} from 'vue'
import axios from "axios";

export default {
    name: 'AuthorPage',
    components: {
        Navbar,
        Footer,
        Message
    },
    setup() {
        const institute_publications = ref([])
        const searchString = ref('')
        const filteredFiles = computed(() => {
            return searchString.value ?
                institute_publications.value.filter(s => s.title[0].toLowerCase().includes(searchString.value.toLowerCase()) || s.author_name.join().toLowerCase().includes(searchString.value.toLowerCase()) || s.institute_name.join().toLowerCase().includes(searchString.value.toLowerCase()) || s.journal[0].toLowerCase().includes(searchString.value.toLowerCase())) :
                institute_publications.value
        })

        return {
            searchString,
            filteredFiles,
            institute_publications
        }
    },
    data() {
        return {
            institute_name: this.$route.params.inst_name,
            institute_auth: [],
            institute_pub_list: [],
            author_journal: [],
            isHidden: false,
            no_content: false,
            abstract_id: 0,
            collectionData: [],
            collection: null,
            isOpen: false,
            checkedNames: [],
            added_collection: false,
            message: {
                text: '',
                type: 'null'
            },

        }
    },
    async mounted() {

        try {

            const response = await axios.post(`${process.env.VUE_APP_SEARCH_API}`, {
                "query": this.institute_name,
                "limit": 50,
                "offset": 0,
            });

            let hits_data = response.data.hits;

            let data = []

            for (let i = 0; i < hits_data.length; i++) {
                data.push(hits_data[i].doc)
            }

            this.institute_publications = data.slice(0, 15);

            for (let inst_pub in this.institute_publications) {
                // this.author_journal.push(this.author_publications[auth_pub].journal[0])
                this.institute_auth.push([{
                    author_name: this.institute_publications[inst_pub].author_name[0],
                    author_slug: this.institute_publications[inst_pub].author_slug[0],
                }]);

            }
            // console.log(this.author_affilications)

            this.no_content = true

        } catch (e) {
            this.errors.push(e)
        }

        // await axios.get(`${process.env.VUE_APP_INSTITUTE_API}${this.$route.params.inst_id}&Key=${process.env.VUE_APP_COMMON_API_KEY}&format=json`)
        //     .then((result) => {

        //     this.institute_name = result.data.data[0].name
        //     this.institute_pub_list = result.data.data[0].pub_lists.slice(0, 10)
        //     this.no_content = true

        // })

        var user_id = this.$store.getters.StateUserInfo.id;
        var user_token = this.$store.getters.StateUserInfo.key;
        const response_colection = await axios.get(`${process.env.VUE_APP_COLLECTIONS_API}${user_id}&Key=${user_token}`);
        this.collectionData = response_colection.data.data

        // for (var pub in this.institute_pub_list) {
        //     await axios.get(`${process.env.VUE_APP_PUBLICATION_API}${this.institute_pub_list[pub]}&Key=${process.env.VUE_APP_COMMON_API_KEY}&format=json`)
        //         .then((result) => {
        //             if (result.data.data[0] != null) {
        //                 this.institute_publications.push(result.data.data[0])
        //                 console.log(this.institute_publications)
        //             }
        //         })
        // }

        // for (var auth in this.institute_publications) {
        //     for (var auth_inst in this.institute_publications[auth].authors) {
        //         for (var inst_id in this.institute_publications[auth].authors[auth_inst].institute) {
        //             if (this.institute_publications[auth].authors[auth_inst].institute[inst_id].id == this.$route.params.inst_id) {
        //                 this.author_affilications.push(this.institute_publications[auth].authors[auth_inst])
        //             }

        //         }

        //     }

        // }

    },

    methods: {

        abstract_show(pub_id) {

            if (this.abstract_id == pub_id) {
                this.isHidden = !this.isHidden;
            } else {
                this.abstract_id = pub_id;
                this.isHidden = true;
            }
        },

        ClickCollection(collection) {
            this.collection = collection;
            this.isOpen = !this.isOpen;
        },

        async addCollection(n, article_id) {
            console.log('boooks')

            try {
                var user_token = this.$store.getters.StateUserInfo.key;

                let collection_details = {
                    "collection_id": n.id,
                    "user_id": this.$store.getters.StateUserInfo.id,
                    "publication_id": [article_id]
                }

                const response = await axios.post(`${process.env.VUE_APP_ADD_COLLECTIONS_API}${user_token}`, collection_details);
                console.log(response.data)
                this.isOpen = !this.isOpen;
                this.collection = null;
                this.added_collection = true
                this.message = {
                    text: "Article added to " + n.name.split(":")[0] + " collection",
                    type: 'success',
                }

                await new Promise((resolve) => {
                    setTimeout(resolve, 5000)
                })
                this.message = {
                    text: "",
                    type: 'null',
                }
                this.added_collection = false

            } catch (e) {
                this.errors.push(e)
            }
        },

        async addCollectionmulti(n) {

            try {
                var user_token = this.$store.getters.StateUserInfo.key;

                let collection_details = {
                    "collection_id": n.id,
                    "user_id": this.$store.getters.StateUserInfo.id,
                    "publication_id": this.checkedNames
                }

                const response = await axios.post(`${process.env.VUE_APP_ADD_COLLECTIONS_API}${user_token}`, collection_details);
                console.log(response.data)
                this.isOpen = !this.isOpen;
                this.collection = null;
                console.log("Hello", response.data.message)
                if (response.data.message == 'collection added sucessfully') {
                    this.added_collection = true
                    this.message = {
                        text: "Article added to " + n.name.split(":")[0] + " collection",
                        type: 'success',
                    }
                    this.checkedNames = new Array()
                    await new Promise((resolve) => {
                        setTimeout(resolve, 5000)
                    })
                    this.message = {
                        text: "",
                        type: 'null',
                    }
                    this.added_collection = false

                }

            } catch (e) {
                this.errors.push(e)
            }
        },

    },

    computed: {},
}
</script>
